import type { PaginatedResponse } from 'modules/avs/avs.types';
import { VerificationStatus } from 'modules/avs/avs.types';

export { VerificationStatus };

export interface FreelancerVerificationState {
  isFetchingVerificationRecords: boolean;
  isUploadingBulkVerification: boolean;
  isFetchingBulkVerificationResult: boolean;
  isFetchingVerificationResultData: boolean;
  verificationRecords: PaginatedResponse<FreelancerVerificationRecord> | null;
  bulkVerificationResponse: FreelancerVerificationResponse<never> | null;
  bulkVerificationResult: FreelancerVerificationBulkDetails | null;
  bulkVerificationResultData: PaginatedResponse<FreelancerVerificationDetails> | null;
}

export interface FreelancerVerificationRecord {
  id: string;
  name: string;
  accounts_processed: number;
  status: VerificationStatus;
  created_at: string;
}

export interface FreelancerVerificationResponse<T> {
  status: VerificationStatus;
  results_id: string;
  message: string;
  timestamp: string;
  status_detail: {
    granular_status_code: string;
    status_additional_info: string;
  };
  verifications?: T;
}

export type FreelancerVerificationBulkDetails = {
  result: {
    verified: number;
    not_verified: number;
    total: number;
  };
  completed_at?: string;
  created_at: string;
  created_by: string;
};

export enum FreelancerStatus {
  verified = 'VERIFIED',
  notVerified = 'NOT_VERIFIED',
}

export enum FreelancerRequestStatus {
  ok = 'OK',
  failed = 'FAILED',
}

export interface FreelancerVerificationDetails {
  id: string;
  application_id: string;
  national_id: string;
  freelancer_number: string;
  status: FreelancerStatus;
  request_status: FreelancerRequestStatus;
  created_at: string;
}

export const failedFreelancerVerificationStatuses = [
  VerificationStatus.invalidParameters,
  VerificationStatus.failed,
  VerificationStatus.internalServerError,
];
